module.exports = __webpack_public_path__ + "static/media/architecture-img.b6703de1.jpg";